import { createContext } from 'react';

export interface TasksAndAlertsHourlyActivityContextData {
    status: 'error' | 'success' | 'pending';
    tasks: number[][] | null;
    alerts: number[][] | null;
    dateString: string | null;
}
export const TasksAndAlertsHourlyActivityContext = createContext<
    TasksAndAlertsHourlyActivityContextData | undefined
>(undefined);
